import { SvgIconComponent } from "@mui/icons-material";
import { Stack, Typography, Badge } from "@mui/material";
import TooltipComponent from "./TooltipComponent";

export const CountBadge = (props: { count: number, prefix: string, icon: SvgIconComponent }) =>
    <TooltipComponent title={<Stack alignItems="center" textAlign="center" ><props.icon fontSize='small' /><Typography fontSize="small">{props.count} {props.prefix}</Typography> </Stack>}>
        <Badge badgeContent={<>{props.count}</>} color="default">
        </Badge>
    </TooltipComponent>